module.exports = __webpack_public_path__ + "img/eraser.3fefa395.svg";